import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

// Batch-scanned USNs, newest first. Red = Save found a problem; amber = not in this combo's floor list (checked on Save).
export const PpScannedList = ({ items, nameOf, onRemove }) => (
  <div className="border rounded">
    <div className="bg-stone-50 p-2 text-xs font-medium text-stone-600">Scanned ({items.length})</div>
    <div className="max-h-[320px] overflow-y-auto" data-testid="scanned-list">
      {items.map((it) => {
        const red = !!it.problem;
        const amber = !red && !it.component_barcode;
        return (
          <div key={it.usn} data-testid={`scanned-row-${it.usn}`}
            className={`p-2 border-t text-xs flex items-center justify-between gap-2 ${red ? 'bg-red-50 border-l-4 border-l-red-500' : amber ? 'bg-amber-50 border-l-4 border-l-amber-400' : 'hover:bg-stone-50'}`}>
            <span className={`font-mono ${red ? 'text-red-800 font-semibold' : ''}`}>{it.usn}</span>
            <span className={`flex-1 text-right ${red ? 'text-red-700' : amber ? 'text-amber-800' : 'text-stone-500'}`} data-testid={`scanned-status-${it.usn}`}>
              {red || amber ? <AlertTriangle className="inline h-3 w-3 mr-1 -mt-0.5" /> : null}
              {it.problem || (amber ? 'Not in this combo\'s floor list — will be checked on Save' : nameOf(it.component_barcode))}
            </span>
            <button type="button" onClick={() => onRemove(it.usn)} className="text-rose-500 hover:text-rose-700" data-testid={`remove-${it.usn}`}>
              <X className="h-3 w-3" />
            </button>
          </div>
        );
      })}
      {!items.length && <div className="p-4 text-stone-400 text-xs text-center">Nothing scanned yet</div>}
    </div>
  </div>
);
